import { normalizeString } from "./stringsFormats";

/**
 * Filtra uma lista de objetos com base em uma query estruturada.
 *
 * @param data - Lista de objetos.
 * @param query - Query de busca, ex: "@cidade:São Paulo" ou "alpes".
 * @returns Objetos filtrados.
 */
export const filterDataByQuery = <T>(data: T[], query: string): T[] => {
  if (!query) return data;

  const normalizedQuery = normalizeString(query.trim());

  // Verifica se é um filtro por campo específico
  const matchFieldQuery = normalizedQuery.match(/^@(\w+):(.+)$/);
  if (matchFieldQuery) {
    const [, rawKey, rawValue] = matchFieldQuery;
    const key = normalizeString(rawKey);
    const value = normalizeString(rawValue);

    return data.filter((item) => {
      for (const k in item) {
        if (
          normalizeString(k).includes(key) &&
          normalizeString(String((item as any)[k] ?? "")).includes(value)
        ) {
          return true;
        }
      }
      return false;
    });
  }

  // Filtro genérico (procura no objeto todo como string normalizada)
  return data.filter((item) => {
    const stringified = normalizeString(JSON.stringify(item));
    return stringified.includes(normalizedQuery);
  });
};
